import React from "react";
import { OrderbookLevel } from "../../sdk/types/data";

interface OrderbookLevelFragmentProps {
  level: OrderbookLevel;
  index: number;
  isLast: boolean;
  depthPercent: number;
  formatPrice: (price: number) => string;
  formatSize: (size: number) => string;
  onPriceClick?: (price: number) => void;
}

export const AskLevelFragment: React.FC<OrderbookLevelFragmentProps> = ({
  level,
  index,
  isLast,
  depthPercent,
  formatPrice,
  formatSize,
  onPriceClick,
}) => {
  const flashClass =
    level.flash === "up"
      ? "flash-up"
      : level.flash === "down"
        ? "flash-down-ask"
        : "";

  const handlePriceClick = () => {
    if (onPriceClick) {
      onPriceClick(level.price);
    }
  };

  return (
    <div
      className={`orderbook-level ask ${flashClass}`}
      style={{
        borderBottom: isLast ? "none" : undefined,
      }}
    >
      {/* Depth bar background */}
      <div
        className="orderbook-depth-bar ask"
        style={{ width: `${depthPercent}%` }}
      />

      {/* Content */}
      <div
        className="orderbook-level-content ask"
        onClick={handlePriceClick}
        style={{
          cursor: onPriceClick ? "pointer" : "default",
        }}
        title={onPriceClick ? "Click to set price" : undefined}
      >
        {formatPrice(level.price)}
      </div>
      <div className="orderbook-level-content right">
        {formatSize(level.size)}
      </div>
      <div className="orderbook-depth-indicator">
        <div className="orderbook-depth-line ask" />
      </div>
    </div>
  );
};

export const BidLevelFragment: React.FC<OrderbookLevelFragmentProps> = ({
  level,
  index,
  isLast,
  depthPercent,
  formatPrice,
  formatSize,
  onPriceClick,
}) => {
  const flashClass =
    level.flash === "up"
      ? "flash-up"
      : level.flash === "down"
        ? "flash-down-bid"
        : "";

  const handlePriceClick = () => {
    if (onPriceClick) {
      onPriceClick(level.price);
    }
  };

  return (
    <div
      className={`orderbook-level bid ${flashClass}`}
      style={{
        borderBottom: isLast ? "none" : undefined,
      }}
    >
      {/* Depth bar background */}
      <div
        className="orderbook-depth-bar bid"
        style={{ width: `${depthPercent}%` }}
      />

      {/* Content */}
      <div
        className="orderbook-level-content bid"
        onClick={handlePriceClick}
        style={{
          cursor: onPriceClick ? "pointer" : "default",
        }}
        title={onPriceClick ? "Click to set price" : undefined}
      >
        {formatPrice(level.price)}
      </div>
      <div className="orderbook-level-content right">
        {formatSize(level.size)}
      </div>
      <div className="orderbook-depth-indicator">
        <div className="orderbook-depth-line bid" />
      </div>
    </div>
  );
};
